
  window.addEventListener("turbolinks:load", () => {
    const toastContainerSelector = "#tombola-toast-container";

    const showTombolaToast = (message) => {
      const container = document.querySelector(toastContainerSelector);
      if (!container) {
        return;
      }

      const toast = document.createElement("div");
      toast.className = "tombola-toast tombola-toast--success";
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      toast.innerHTML = `
        <span class="tombola-toast__icon" aria-hidden="true">
          <i class="fas fa-check-circle"></i>
        </span>
        <span>${message}</span>
      `;

      container.appendChild(toast);

      requestAnimationFrame(() => {
        toast.classList.add("show");
      });

      window.setTimeout(() => {
        toast.classList.remove("show");
        window.setTimeout(() => {
          toast.remove();
        }, 200);
      }, 4000);
    };

    const links = document.querySelectorAll("a[data-tombola-interest]");
    links.forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();
        const { tombolaInterest } = element.dataset;
        $("#profile_tombola_interest").attr("value", tombolaInterest);

        $.ajax({
          url: "/mynails/profile/update",
          method: "PUT",
          dataType: "html",
          data: { tombola_interest: tombolaInterest },
          error: function (xhr, status, error) {
            console.error("AJAX Error: " + status + error);
          },
          success: function (response) {
            const updatedSelectedTombola = document.querySelector("#tombola_favorite");
            if (updatedSelectedTombola) {
              const tempContainer = document.createElement("div");
              tempContainer.innerHTML = response.trim();
              const replacement = tempContainer.querySelector("#tombola_favorite");

              if (replacement) {
                updatedSelectedTombola.replaceWith(replacement);
              } else {
                updatedSelectedTombola.textContent = response.trim();
              }
            }

            showTombolaToast("Je voorkeur is opgeslagen!");
          },
        });
      });
    });
  });
